<app-header></app-header>
<app-side-bar></app-side-bar>
<section id="main">
  <div class="wrapper" id="boxscroll">
      <router-outlet></router-outlet>    
  </div>
</section>


// WEBPACK FOOTER //
// /build/client-cms/src/app/layout/layout.component.html